"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTracking = void 0;

function getTracking() {
  if (typeof window === 'undefined') {
    throw new Error('EClientOnly');
  }

  return new Promise(function (resolve) {
    // @ts-ignore
    var tracking = window.tracking;

    if (tracking && tracking.fullfill) {
      resolve(tracking);
    } else {
      window.addEventListener('tracking-created', function (event) {
        // @ts-ignore
        resolve(event.detail || window.tracking);
      });
    }
  });
}

exports.getTracking = getTracking;